<div class="wrapper">
  <div class="container">
    <div class="page-header">
      <h1 class="heading">アセスメント一覧</h1>
      <div class="actions">
        <button rectangle [matMenuTriggerFor]="userRegistrationMenu">
          <mat-icon>add</mat-icon>エクスポート
          <span class="vertical-line"></span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #userRegistrationMenu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="exportAssessments()">
              キーアクション評価
            </button>
            <button mat-menu-item (click)="exportAssessmentSummaries()">
              サマリー
            </button>
            <mat-divider></mat-divider>
            <button
              mat-menu-item
              [disabled]="this.exportingIntegrated"
              (click)="exportIntegratedAssessments()"
            >
              @if (this.exportingIntegrated) {
                <mat-icon>hourglass_empty</mat-icon>
              }
              統合エクスポート
            </button>
          </ng-template>
        </mat-menu>
      </div>
    </div>
    <div
      class="search-box"
      [class.with-tag-filter]="this.hasAssessmentTagMasters"
      [class.with-report-to-filter]="this.reportToOptions.length > 0"
    >
      <app-search-input
        (changed)="this.queryNameInput$.next($event)"
        [placeholder]="'名前、部署などで検索'"
      ></app-search-input>
      @if (this.hasAssessmentTagMasters) {
        <app-multiple-select
          data-testid="assessment-tag-filter"
          [fieldName]="'タグ：'"
          [items]="this.tagItems"
          [matchOptions]="tagMatchOptions"
          [matchMode]="tagMatch"
          (changeMatchMode)="changeTagMatch($event)"
          (changeSelected)="this.changeSelectedTags($event)"
        ></app-multiple-select>
      }
      @if (this.reportToOptions.length > 0) {
        <div class="report-to-filter">
          <select
            aria-label="上司"
            [ngModel]="reportToUserId"
            (ngModelChange)="changeReportTo($event)"
          >
            <option value="">上司：未選択</option>
            @for (option of reportToOptions; track option.userId) {
              <option [value]="option.userId">{{ option.userName }}</option>
            }
          </select>
        </div>
      }
    </div>
    <div
      class="bulk-actions"
      [ngClass]="{ 'visible-hidden': this.checkedState === 'UNCHECKED' }"
    >
      <div class="selected-count">{{ checkedCount }}&nbsp;{{ '件選択中' }}</div>
      <button
        type="button"
        class="action-button"
        (click)="this.deleteAssessmentsBulk()"
      >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        {{ 'アセスメントの削除' }}
      </button>
    </div>
    <div
      #tableContainer
      class="table-container"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDisabled]="this.loading"
      (scrolled)="loadMoreAssessments()"
    >
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              [checked]="this.checkedState === 'CHECKED'"
              [indeterminate]="this.checkedState === 'INDETERMINATE'"
              (change)="this.checkAllAssessments($event.checked)"
            ></mat-checkbox>
          </th>
          <td
            mat-cell
            *matCellDef="let assessment"
            (click)="selectCellClick($event)"
          >
            <mat-checkbox
              #checkbox
              [checked]="assessment.selected"
              [disabled]="!this.isDeletableAssessment(assessment)"
              (change)="this.checkChanged(checkbox, assessment)"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="userName">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="sortable"
            (click)="this.sort('userName')"
          >
            メンバー
            @if (this.sortField === 'userName') {
              {{ this.sortDirection === 'asc' ? '▲' : '▼' }}
            }
          </th>
          <td mat-cell *matCellDef="let assessment">
            {{ assessment.user.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="userDepartmentName">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="sortable"
            (click)="this.sort('userDepartmentName')"
          >
            部署
            @if (this.sortField === 'userDepartmentName') {
              {{ this.sortDirection === 'asc' ? '▲' : '▼' }}
            }
          </th>
          <td mat-cell *matCellDef="let assessment">
            {{ assessment.user.departmentName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="businessMeetingName">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="sortable"
            (click)="this.sort('businessMeetingName')"
          >
            商談
            @if (this.sortField === 'businessMeetingName') {
              {{ this.sortDirection === 'asc' ? '▲' : '▼' }}
            }
          </th>
          <td mat-cell *matCellDef="let assessment">
            <a
              [routerLink]="['/home']"
              [queryParams]="{
                'user-id': assessment.user.id,
                'assessment-id': assessment.id,
              }"
              (click)="$event.stopPropagation()"
            >
              {{ assessment.businessMeeting.title }}
            </a>
          </td>
        </ng-container>

        <ng-container matColumnDef="businessMeetingRecordDate">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="sortable"
            (click)="this.sort('businessMeetingRecordDate')"
          >
            商談日
            @if (this.sortField === 'businessMeetingRecordDate') {
              {{ this.sortDirection === 'asc' ? '▲' : '▼' }}
            }
          </th>
          <td mat-cell *matCellDef="let assessment">
            {{
              $safeNavigationMigration(assessment.businessMeeting?.recordDate)
                | date: 'yyyy/MM/dd'
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountName">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="sortable"
            (click)="this.sort('accountName')"
          >
            顧客名
            @if (this.sortField === 'accountName') {
              {{ this.sortDirection === 'asc' ? '▲' : '▼' }}
            }
          </th>
          <td mat-cell *matCellDef="let assessment">
            {{ assessment.businessMeeting?.account?.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="averageScore">
          <th mat-header-cell *matHeaderCellDef>{{ overallScoreLabel }}</th>
          <td mat-cell *matCellDef="let assessment">
            @if (
              assessment.status === 'COMPLETED' && assessment.skipEvaluation
            ) {
              <span class="skip-evaluation">評価なし</span>
            } @else if (assessment.status === 'COMPLETED') {
              <!-- GRADE モード: overallGrade を表示。
                閾値未マッチで null になった場合は『—』プレースホルダで表示する
                (要件「具体的な点数を見せない」を遵守、admin 警告 UI で運用検知) -->
              @if (assessment.overallScoreLogicType === 'GRADE') {
                <span class="grade-display">{{
                  assessment.overallGrade ?? '—'
                }}</span>
              } @else {
                <!-- 数値とサフィックス（点/pts）の間に空白を出さないため、
                  interpolation を要素で包み周囲の改行を空白のみノードとして除去させる -->
                <ng-container>{{
                  assessment.overallScore | number: '1.0-2'
                }}</ng-container>
                @switch (assessment.overallScoreLogicType) {
                  @case ('WEIGHTED') {
                    <span class="weighted-score-suffix">点</span>
                  }
                  @case ('AVERAGE') {
                    <ng-container>pts</ng-container>
                  }
                }
              }
            } @else if (
              assessment.status === 'IN_PROGRESS' && assessment.skipEvaluation
            ) {
              <!-- skip テナントでは評価は走らないため「評価中」と表示しない -->
              処理中...
            } @else if (assessment.status === 'IN_PROGRESS') {
              評価中...
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef>タグ</th>
          <td mat-cell *matCellDef="let assessment">
            <div class="tag-list">
              @for (tag of assessment.tags; track tag.tagMasterId) {
                <span class="badge assessment-tag">{{ tag.name }}</span>
              }
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let assessment" class="clip">
            @if (this.isDeletableAssessment(assessment)) {
              <app-context-menu
                [menus]="this.contextMenu"
                (clicked)="contextMenuClick($event, assessment)"
              >
              </app-context-menu>
            }
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="navigateToHome($event, row.user.id, row.id)"
        ></tr>
      </table>
      <app-loading [showLoading]="this.loading"></app-loading>
      @if (this.dataSource.length === 0 && !this.loading) {
        <div class="empty">該当なし</div>
      }
    </div>
  </div>
</div>
